import React from 'react';
import PT from 'prop-types';
import { FormMode } from '../../../../../screens/Admin/constants/constants';

import ModalForm from 'Components/Admin/Form/components/ModalForm/ModalForm';

const SubForm = ({ name, mode, closeUrl, history, items, ...props }) => {
  const getTitle = () => (mode === FormMode.UPDATE ? 'Edit ' : 'Add ') + name;
  const handleClose = () => history.push(closeUrl);

  return (
    <ModalForm
      title={getTitle()}
      onClose={handleClose}
      formItems={items}
      testId={`${name}-${mode}-sub-form`}
      className="sub-form"
      {...props}
    />
  );
};

SubForm.propTypes = {
  items: PT.arrayOf(PT.any),
  initialValues: PT.object,
  onSubmit: PT.func,
  name: PT.string,
  closeUrl: PT.string,
  mode: PT.string,
};

export default SubForm;
